<template>
  <v-main>
    <Settings />
  </v-main>
</template>

<script>
import Settings from '@/components/settings'
export default {
  name: 'view-settings',
  components: { Settings }
}
</script>

<style scoped>
</style>
